<template>
  <div
    v-show="!enough"
    ref="target"
    :class="$b()"
  >
    <VisionLoadingSpinner
      :loading="!enough"
    />
  </div>
</template>

<script>

export default {
  name: 'InfiniteScroll',
  props: {
    enough: {
      type: Boolean,
      default: false
    }
  },
  emits: ['load-more'],
  data: () => ({
    observer: null
  }),
  mounted () {
    this.setupInfiniteScrollObserver()
  },
  beforeUnmount () {
    if (this.observer) {
      this.observer.disconnect()
    }
  },
  methods: {
    setupInfiniteScrollObserver () {
      this.observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting && !this.enough) {
          this.$emit('load-more')
        }
      })

      this.observer.observe(this.$refs.target)
    }
  }
}
</script>

<style lang="postcss">
.InfiniteScroll {
  @apply relative mt-lg mb-md;
}
</style>
